<template lang="html">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    class="icon discover"
    viewBox="0 0 20 32"
  >
    <path d="M19.596 13.867h-7.040l1.709-13.861-13.861 18.126h7.040l-1.709 13.861z" />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.menu__item.router-link-active .icon {
  &.discover {
    stroke-width: 1.5pt;
    animation: strokeDiscover 1.2s reverse;
  }

  @keyframes strokeDiscover {
    100% {
      stroke-dashoffset: 300;
    }
  }
}
.icon.discover {
  width: 2.3em;
  height: 2.3em;
  stroke-width: 1pt;
  stroke-dasharray: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/MobileNavbar/svgs/SvgDiscover.vue